/**
 * 获取指定页面的banner
 * @returns banner
 * @param id
 * @param type
 */
export async function fetchNoIndex(id: number, type: number): Promise<number> {
  return http
    .get<any>('/v1/web_content/no_index', {
      id,
      type
    })
    .then((res) => {
      return res?.data?.data
    })
    .catch(() => {
      return 0
    })
}
